import { useEffect, useState } from "react";
import { Mic } from "lucide-react";
import { toast } from "sonner";
import { KeyboardPanel, SHORTCUT_LABEL } from "@/components/VoiceKeyboard";

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copied — paste it anywhere");
  } catch {
    toast.error("Couldn't copy. Select the text and copy manually.");
  }
};

export default function FloatingMic() {
  const [open, setOpen] = useState(false);
  const [session, setSession] = useState(0);
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("mulankan:floating", { detail: open }));
    return () => window.dispatchEvent(new CustomEvent("mulankan:floating", { detail: false }));
  }, [open]);
  useEffect(() => {
    const openKb = () => { setSession((n) => n + 1); setOpen(true); };
    window.addEventListener("mulankan:open-kb", openKb);
    return () => window.removeEventListener("mulankan:open-kb", openKb);
  }, []);
  useEffect(() => {
    const key = (e) => {
      if (e.code !== "Space" || !e.shiftKey || !(e.ctrlKey || e.metaKey)) return;
      e.preventDefault();
      if (open) window.dispatchEvent(new CustomEvent("mulankan:kb", { detail: "done" }));
      else { setSession((n) => n + 1); setOpen(true); }
    };
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [open]);

  return (
    <>
      {open && (
        <div className="fixed inset-0 z-[70] flex items-end sm:items-end sm:pb-6 bg-black/50 backdrop-blur-[2px] fade-up" data-testid="voice-keyboard"
          onMouseDown={(e) => e.target === e.currentTarget && setOpen(false)}>
          <KeyboardPanel key={session} p="kb" onClose={() => setOpen(false)} />
        </div>
      )}
      {!open && (
        <button onClick={() => { setSession((n) => n + 1); setOpen(true); }} data-testid="floating-mic-button" title={`Voice keyboard (${SHORTCUT_LABEL})`}
          className="hidden md:flex fixed bottom-5 right-5 z-50 items-center gap-3 rounded-full pl-3 pr-4 h-12 border bg-[#17130F]/90 backdrop-blur-xl border-white/10 text-[var(--ink)] transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-[var(--accent)]/60">
          <Mic size={18} /> <span className="text-xs font-semibold tracking-wide">Voice keyboard</span>
        </button>
      )}
    </>
  );
}
